<template>
  <btn-primary
    :text="$t('app.financial.payableAccounts.list.terminateButton')"
    type="submit"
    flex-row-reverse
    :disabled="totalItens === 0"
    @click="confirmTerminatePayableAccounts()"
  />
</template>

<script>
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import PayableAccountsRequest from 'Domain/financial/PayableAccountsRequest';
import NotificationMixin from 'Support/mixins/notification-mixin';

export default {
  name: 'PayableAccountsTerminateButton',
  components: {
    BtnPrimary,
  },
  mixins: [NotificationMixin],
  data: () => ({
    totalItens: 0,
  }),
  created() {
    this.$root.$on('total-itens-PayableAccountsCrudList', (data) => {
      this.totalItens = data;
    });
  },
  methods: {
    confirmarAcao(title, text, callbackFn) {
      this.showConfirmDialog({
        title,
        text,
        confirmButtonText: this.$t('app.financial.payableAccounts.list.confirm'),
        cancelButtonText: this.$t('app.financial.payableAccounts.list.cancel'),
      })
        .then((data) => {
          if (data.value) {
            callbackFn();
          }
        });
    },
    confirmTerminatePayableAccounts() {
      this.confirmarAcao(
        this.$t('app.financial.payableAccounts.list.confirmationTitle'),
        this.$t('app.financial.payableAccounts.list.terminateConfirmationMessage', { count: this.totalItens }),
        this.terminatePayableAccounts,
      );
    },
    terminatePayableAccounts() {
      const payload = this.$route.query;
      if (payload.page) {
        delete payload.page;
      }
      this.callService(
        this.$t('app.financial.payableAccounts.list.terminateSuccessMessage'),
        PayableAccountsRequest.manuallyTerminate(this.$route.query),
      );
    },
    callService(successMessage, requestService) {
      const loader = this.$loading.show();
      requestService
        .then(() => {
          this.showSuccessToast({
            text: successMessage,
          });
        })
        .catch(({ response }) => {
          const { data } = response;
          this.showErrorToast({
            text: data.message,
          });
        })
        .finally(() => {
          this.$root.$emit('refresh-crud-payable', {});
          loader.hide();
        });
    },
  },
};
</script>
